import { Web3_ENV } from "env";
import { http, createConfig } from "wagmi";
import { bsc , bscTestnet } from "wagmi/chains";
import { metaMask, walletConnect, coinbaseWallet } from "wagmi/connectors";

export const API_KEY_RATE = "55457193d4f249d79f6cc439bad2b4a9";

export const config = createConfig({
  chains: [Web3_ENV === "mainnet" ? bsc : bscTestnet],
  connectors: [
    metaMask(),
    walletConnect({
      projectId: '14f67343a5062c491fd801df1afa7cbe',
      showQrModal: true,
      qrModalOptions: {
        themeVariables: {
          "--wcm-z-index": "9999",
        }
      },
      metadata: {
        name: 'LUMIR',
        description: 'Connect to LUMIR',
        url: 'https://lumir.finance',
        icons: ['https://lumir.finance/images/favicon.png'],
      },
    }),
    coinbaseWallet({
      appName: 'LUMIR',
      appLogoUrl: 'https://lumir.finance/images/favicon.png',
      jsonRpcUrl: 'https://bsc-mainnet.infura.io/v3/' + API_KEY_RATE,
    }),

  ],
  transports: {
    [bsc.id]: http(`https://bsc-mainnet.infura.io/v3/${API_KEY_RATE}`),
    [bscTestnet.id]: http(`https://bsc-testnet.infura.io/v3/${API_KEY_RATE}`),
  },
});
